import Content from "../common/Content";
import Footer from "../common/Footer";
import Header from "../common/Header";
import DataTable from "react-data-table-component";
import DataTableExtensions from 'react-data-table-component-extensions';
import 'react-data-table-component-extensions/dist/index.css';
import { API } from "../../helper/Api";
import { useState, useEffect,useRef, useDebugValue } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { RotatingLines } from "react-loader-spinner";
import $ from "jquery";
import SessionHandler from "../common/SessionHandler";
import { useRole } from "../contextApi/RoleContext";
import { Link, useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import { CSVLink } from 'react-csv'; 
import * as XLSX from 'xlsx';
import { forEach } from "jszip";
import { jsPDF } from "jspdf"; // Import jsPDF
import "jspdf-autotable"; // Import the autoTable plugin







export default function Poc() {
  const navigate = useNavigate();
  const contentRef = useRef(null);
  const API_URL = process.env.REACT_APP_BASE_URL;
  const { setRole, role, setPermission, permission,userDetails } = useRole();
  const [isLoading, setIsLoading] = useState(true);
  const [items, setItems] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [pending, setPending] = useState(false);
  const [storeCurrPerm, setStoreCurrPerm] = useState();
  const [currentPage, setCurrentPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(250); 
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [availFromDate, setAvailFromDate] = useState('');
  const [availToDate, setAvailToDate] = useState('');
  const [isOpen, setIsOpen] = useState(false);
  const [dynamicFields, setDynamicFields] = useState([{ filterName: "", filterType: "", filterValue: "",filterTypeOpt:[],filterNameOpt:[{value:"CLU",name:"CLU"},{value:"Description",name:"Description"},{value:"Cost",name:"Cost"},{value:"Base Price",name:"Base Price"},{value:"Primary Vendor",name:"Primary Vendor"},{value:"NSO",name:"NSO"},{value:"Status",name:"Status"},{value:"Department",name:"Department"},{value:"Class",name:"Class"},{value:"Pack",name:"Pack"},{value:"Web",name:"Web"},{value:"Available Date",name:"Available Date"},{name:'Rec Modified',value:"Rec Modified"}] }]);
  const [storeFilterRec,setStoreFilterRec]=useState([]);
  const [finalRec,setFinalRec]=useState([]);
  const [showRec,setShowRec]=useState(false);
  const [showDatePickerModal, setShowDatePickerModal] = useState(false);
  const [track1, setTrack1] = useState(false);
  const [isRecUpdated,setIsRecUpdated] =useState("");
  const [search,setSearch]=useState("");
  const [prices, setPrices] = useState([]);
  const [filteredRecCount,setFilteredRecCount]=useState("");
  const [storeCode, setStoreCode] = useState([]);
  const [showModal1, setShowModal] = useState(false);
  const [columns,setColumns]=useState([
   {
      id:1,
      name: 'CLU',
      selector:row =>row.CLU,
                                        filterable: true,
                                      // reorder: true,
                                        sortable: true,
                                        columnVisible:true,
                                        cell: row => {
                                          let link= `/catalog-price-update?id=${row.StyleNo}`;
                                          return row.CLU ? storeCurrPerm?.edit_permission === "1" ? (
                                            
                                             <Link
                                             to={link}
                                             value={row.StyleNo}
                                             data-id={row.StyleNo}
                                             className="catalog-price-update"
                                            >
                                             {row.CLU}
                                            </Link>
                                                                          ):  (
                                                                            row.CLU
                                                                           
                                                                          ) : (
                                                                            ""
                                                                          )},
                                                                          style: {
                                                                            position: "sticky",
                                                                            left: 0,
                                                                            backgroundColor: "white",
                                                                            zIndex: 2, // Ensures it stays above other content
                                                                            
                                                                          },
                                                                          width:"180px"
                                                                        

      
    },
    {
      id:2,
      name: 'DESCRIPTION',
      selector: row => row.DESCRIPTION,
      reorder: true,
      sortable: true,
      columnVisible:false,
      // cell: row => row.DESCRIPTION,
      cell: row => row.DESCRIPTION,
      // style: {
      //   position: "sticky",
      //   left: "100px",
      //   backgroundColor: "white",
      //   zIndex: 2, // Ensures it stays above other content
      // },
      width:"180px"
    },
    {
      id:3,
      name: 'COST',
      selector: row => row.COST,
      reorder: true,
      sortable: true,
      columnVisible:true,
      cell: row => row.COST,
      width:"130px"
    },
    {
      id:4,
      name: 'BASE PRICE',
      selector: row => row["BASE PRICE"],
      reorder: true,
      sortable: true,
      columnVisible:true,
      cell: row => row.PRICE,
      width:"130px"
    }, 
    {
      id:5,
      name: 'STORE PRICE',
      class:'storeprice_viweBtn',
      cell:(row) => <button onClick={() => toggleModal(row)} style={{background:"#7CB342",color:"#fff",border:"none",borderRadius: "10px",padding:"5px"}}>View Price</button>,
      reorder: true,
      sortable: true,
      columnVisible:true,
      width:"130px"
    }, 
    {
      id:6,
      name: 'OH',
      reorder: true,
      sortable: true,
      columnVisible:true,
      width:"180px"
    },  
    {
      id:7,
      name: 'OO',
      reorder: true,
      sortable: true,
      columnVisible:true,
      width:"130px"
    },
    {
      id:8,
      name: 'DEPARTMENT',
      selector:row=>row.DEPARTMENT,
      // selector: row => {
      //   return row.DCSS.DeptName
      //     ? `${row.DCSS.DeptName}`
      //     : "";
      // },      
      reorder: true,
      sortable: true,
      columnVisible:true,
      width:"180px"
    },
    {
      id:9,
      name: 'CLASS',
      selector:row=>row.CLASS,
      // selector: row => {
      //   return row.DCSS.ClassName
      //     ? `${row.DCSS.ClassName}`
      //     : "";
      // },       
      reorder: true,
      sortable: true,
      columnVisible:true,
      width:"180px"
    }, 
    {
      id:10,
      name: 'PRIMARY VENDOR',
      selector:row=>row['PRIMARY VENDOR'],
      // selector: row => {
      //   return row.PrimaryVendorIdentifier
      //     ? `${row.PrimaryVendorIdentifier}`
      //     : "";
      // },
      reorder: true,
      sortable: true,
      columnVisible:true,
      width:"180px"
    },
    {
      id:11,
      name: 'SECONDARY VENDOR',
      reorder: true,
      sortable: true,
      columnVisible:true,
      width:"180px"
    },                                 
    {
      id:12,
      name: 'PACK',
      selector:row=>row.PACK,
      // selector: row => {
      //   return row.Items[0].Custom.CustomNumber1
      //     ? `${row.Items[0].Custom.CustomNumber1}`
      //     : "";
      // },      
      reorder: true,
      sortable: true,
      columnVisible:true,
      width:"130px"
    },         
    {
      id:13,
      name: 'NSO',
      selector:row=> row.NSO,
      cell: row => {
        return row.NSO === true ? (
          <span className="mdi mdi-checkbox-marked-circle nso_true"></span>
        ) : (
          <span className="disableNSO">N</span>
        );
      },
      className: 'nso_details',
      reorder: true,
      sortable: true,
      columnVisible:true,
      width:"130px"
      
    },
    {
      id:14,
      name: 'WEB',
      selector:row=> row.WEB, 
      cell: row => {
        return row.WEB12 ? row.WEB === "yes" ? (
          <span className="mdi mdi-checkbox-marked-circle nso_true"></span>
        ) : (
          <span className="disableNSO">N</span>
        ) : "";
      },         
      reorder: true,
      sortable: true,
      columnVisible:true,
      width:"130px"
    },
    {
      id:15,
      name: 'CURRENT CATALOG',
      selector:row=>row["CURRENT CATALOG"],
      reorder: true,
      sortable: true,
      columnVisible:true,
      width:"180px"
    }, 
    {
      id:16,
      name: 'AVAILABLE DATE',
      selector:row=>row['AVAILABLE DATE'],
      // selector: row => {
      //   return row.Items[0].DateAvailable
      //     ? `${formatDate(row.Items[0].DateAvailable)}`
      //     : "";
      // },       
      reorder: true,
      sortable: true,
      columnVisible:true,
      width:"150px"
    }, 
    // {
    //   id: 17,
    //   name: 'STATUS',
    //   selector: row => row.STATUS,
    //   cell: row => {
    //     if (row.STATUS === "Approved") {
    //       return <span className="mdi mdi-checkbox-marked-circle nso_true"></span>;  // Green check for approved
    //     } else if (row.STATUS === "Pending") {
    //       return <span className="mdi mdi-clock"></span>;  // Clock for pending
    //     } else if (row.STATUS === "Rejected") {
    //       return <span className="mdi mdi-close-circle"></span>;  // Red close circle for rejected
    //     } else if (row.STATUS === "In Active") {
    //       return <span className="mdi mdi-pause-circle"></span>;  // Pause circle for inactive
    //     } else if (row.STATUS === "Discontinued") {
    //       return <span className="mdi mdi-delete-circle"></span>;  // Delete circle for discontinued
    //     }
      
    //   },
    //   reorder: true,
    //   sortable: true,
    //   columnVisible: true,
    //   width: "150px"
    // }
    {
      id: 17,
      name: 'STATUS',
      selector: row => row.STATUS,
      cell: row => {
        let content;
        let backgroundColor;
    
        switch (row.STATUS) {
          case "Approved":
            content = <span className="mdi mdi-checkbox-marked-circle nso_true"></span>; // Icon for Approved
            break;
          case "Pending":
            content = <span
              style={{
                display: 'inline-block',
                width: '20px',
                height: '20px',
                borderRadius: '50%',
                backgroundColor: "#FF9800", // Orange for Pending
                color: '#fff',
                textAlign: 'center',
                lineHeight: '20px',
                fontWeight: 'bold',
                fontSize: '12px',
              }}
            >
              P
            </span>;
            break;
          case "Rejected":
            content = <span
              style={{
                display: 'inline-block',
                width: '20px',
                height: '20px',
                borderRadius: '50%',
                backgroundColor: "#F44336", // Red for Rejected
                color: '#fff',
                textAlign: 'center',
                lineHeight: '20px',
                fontWeight: 'bold',
                fontSize: '12px',
              }}
            >
              R
            </span>;
            break;
          case "In Active":
            content = <span
              style={{
                display: 'inline-block',
                width: '20px',
                height: '20px',
                borderRadius: '50%',
                backgroundColor: "#9E9E9E", // Grey for In Active
                color: '#fff',
                textAlign: 'center',
                lineHeight: '20px',
                fontWeight: 'bold',
                fontSize: '12px',
              }}
            >
              IA
            </span>;
            break;
          case "Discontinued":
            content = <span
              style={{
                display: 'inline-block',
                width: '20px',
                height: '20px',
                borderRadius: '50%',
                backgroundColor: "#607D8B", // Blue-grey for Discontinued
                color: '#fff',
                textAlign: 'center',
                lineHeight: '20px',
                fontWeight: 'bold',
                fontSize: '12px',
              }}
            >
              D
            </span>;
            break;
          default:
            // content = <span
            //   style={{
            //     display: 'inline-block',
            //     width: '20px',
            //     height: '20px',
            //     borderRadius: '50%',
            //     backgroundColor: "#9E9E9E", // Grey for Unknown
            //     color: '#fff',
            //     textAlign: 'center',
            //     lineHeight: '20px',
            //     fontWeight: 'bold',
            //     fontSize: '12px',
            //   }}
            // >
            //   ?
            // </span>;
        }
    
        return content;
      },
      reorder: true,
      sortable: true,
      columnVisible: true,
      width: "150px"
    }
    
    
                
    // {
    //   id:18,
    //   name: 'ACTIVE',
    //   selector:row=>row.ACTIVE,   
    //   reorder: true,
    //   sortable: true,
    //   columnVisible:true,
    //   width:"150px"
    // },
  ]);
//   const [visibleColumns, setVisibleColumns] = useState(columns.map(col => {name:col.name;}));
  let track=false;
  let keepStoreCode=[];

 
  

  const toggleColumn = (id) => {
    console.log(columns)
   // return false
    setColumns((prev) =>
      prev.map((col) =>
        col.id === id ? { ...col, columnVisible: !col.columnVisible } : col
      )
    );
   setTrack1(true);
    console.log("toggle",columns)
  };
  
   ///get the store code /////
   const fetchStoreCode = async () => {
    try {
      const res = await fetch(`${API_URL}location.php`);
      // Check if the response is successful (status 200)
      if (!res.ok) {
        throw new Error("Network response was not ok");
      }
      const result = await res.json();

      const extractCode = result.ApiDocument.Response.Locations.map(
        (item) => {
          return { code: item.Code,name: item.Name };
        }
      ).filter((item) => item.code);
     // console.log("test",extractCode)
     keepStoreCode=extractCode;
      setStoreCode(extractCode);
      // if(userDetails.usertype !=="CORP"){
      //   const filterCodeBasedOnUser= extractCode.filter(item => userDetails.storecode.some(its=> its.storecode === item.code));
      //   setStoreCode(filterCodeBasedOnUser);
      //   console.log("filtered code",filterCodeBasedOnUser)
      // }else{
      //   setStoreCode(extractCode);
      // }
      
      
      // console.log("store code", extractCode);
    } catch (error) {
      //console.error("Error fetching data:", error);
    }
  };

  useEffect(()=>{
    fetchStoreCode();
  },[])

  const toggleModal = (row) => {
console.log("check row",row)
const extractPriceLevel=row.ALL_PRICES;
const getUpdatedPrice =extractPriceLevel.map((item)=>{
      let matchedStoreCode = keepStoreCode.find(it=> it.code === item.PriceLevel)
      if(matchedStoreCode){
        return {...item,strname:matchedStoreCode.name}
      }else{
        return {...item,strname:''}
      }
    });
    setPrices(getUpdatedPrice);
    setShowModal(!showModal1);
    // const id = row;
    // API.getSpecificData({id})
    // .then(datas => {
    //   const items = datas.ApiDocument.Response.Styles.flatMap(style => style);
    //   // setPosts(items);
    //   console.log(items)
    
    // const filterStyleNo= items.find((item)=> Number(item.StyleNo) === row);
   // console.log(filterStyleNo);
   // return "";
    // const getUpdatedPrice =items[0].Items[0].Prices?.map((item)=>{
    //   let matchedStoreCode = storeCode.find(it=> it.code === item.PriceLevel)
    //   if(matchedStoreCode){
    //     return {...item,strname:matchedStoreCode.name}
    //   }else{
    //     return {...item,strname:''}
    //   }
        
  //})
    // setPrices(getUpdatedPrice);
    // setShowModal(!showModal1);
    // })
    // .catch((err) => console.log(err))
  };
 const toggleCloseModal = () => {
  setShowModal(!showModal1);

 }



  
   //setVisibleColumns((prev) =>
    //   prev.includes(name) ? prev.find((colId) => colId !== name) : [...prev, name]
    // );
console.log("check column before filter",columns);
  const filteredColumns = columns.filter((col) => col.columnVisible ===true);
  //handleColumnOrderChange(filteredColumns);
 //console.log(filteredColumns);
  
  const toggleCollapse = () => {
    setIsOpen((prev) => !prev);
  };

  useEffect(() => {
    if (contentRef.current) {
      // Reset max-height to auto when content is fully expanded
      if (isOpen) {
        contentRef.current.style.maxHeight = `${contentRef.current.scrollHeight}px`;
      } else {
        contentRef.current.style.maxHeight = '0';
      }
    }
  }, [isOpen]);

  useEffect(() => {
    catalogLists(currentPage,rowsPerPage);
    const currentPagePerm = permission.find((item) => item.category_id === "3");
    setStoreCurrPerm(currentPagePerm);
    track=true;
    //get the order column from cookies
    const savedColumnOrder = Cookies.get('ProductsOrder2');
   if(savedColumnOrder){
    const convertJson=JSON.parse(savedColumnOrder);
    const updatedColumns = updateOriginalColumns(convertJson);
    console.log("original rec",updatedColumns);
   
    const updatedColumnBasedOnCookies = updatedColumns.map((item) => {
        let updatedItem = { ...item }; // Create a new object to avoid mutation
    
        let isVisible = false; // Default to false
        convertJson.forEach((it) => {
            if (it.id === item.id && it.columnVisible === true) {
                isVisible = true;
            }
        });
    
        updatedItem.columnVisible = isVisible; // Set the correct value
        return updatedItem; // Return the new object
    });
    setColumns(false);
    setColumns(updatedColumnBasedOnCookies)
    
    console.log("final", updatedColumnBasedOnCookies);
    
    // setColumns((prev) =>
    //     updatedColumns.map((item) => {
    //         let updatedItem = { ...item };
    //         convertJson.forEach((it) => {
    //             if (it.id === item.id) {
    //                 updatedItem[it.columnVisible] = true; // Use dynamic key
    //             }else{
    //                 updatedItem[it.columnVisible] = false; // Use dynamic key
    //             }
    //         });
    //         console.log(updatedItem)
    //         return updatedItem;
            
    //     })
    // ); 
   }
  }, []);

  useEffect(()=>{
    // console.log(track)
    
     if(!track){
       if(rowsPerPage >0){
         catalogLists();
       }else{
         catalogLists1(currentPage,rowsPerPage);
       }
       
     }
     
   },[currentPage,rowsPerPage])

   useEffect(()=>{
   // console.log("track1",track1)
    if(track1){
   //  alert("test")
  // console.log("useEffect column",columns);
      handleColumnOrderChange(columns,"visiblecol");
    }

  },[track1,columns])



  // useEffect(() => {
  //   setFinalRec(filteredSelectedColumn())
  // }, [items,storeFilterRec]);

  /////convert the time into US format 

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    
    // Format the date as MM/DD/YYYY
    const month = (date.getMonth() + 1).toString().padStart(2, '0'); // getMonth() is zero-indexed
    const day = date.getDate().toString().padStart(2, '0');
    const year = date.getFullYear();

    // Format the time as hh:mm AM/PM
    let hours = date.getHours();
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const isAM = hours < 12;
    
    // Convert to 12-hour format
    hours = hours % 12 || 12; // The hour 0 should be 12 in 12-hour format
    const period = isAM ? 'AM' : 'PM';

    return `${month}/${day}/${year}`;
  };


  //////end////////////////////////

  const catalogLists = async(page) => {
    setPending(true);

    API.getData(currentPage,rowsPerPage)
      .then(async (datas) => {
        const items1 = datas.ApiDocument.Response.Styles.flatMap(
          (style) => style
        );
      //  console.log("catalog list", items);
        const totalRecords = datas.ApiDocument.TotalRecords;
        setItems(filteredSelectedColumn(items1));
        setTotalRecords(totalRecords);
        setPending(false);
        setIsLoading(false);
        setCurrentPage(0);
        setRowsPerPage(400);
       //setFinalRec(filteredSelectedColumn());
      })
      .catch((err) => console.log(err));
  };

 const catalogLists1 = async() => {
  //  setPending(true);

    API.getData(currentPage,rowsPerPage)
      .then((datas) => {
        const items2 = datas.ApiDocument.Response.Styles.flatMap(
          (style) => style
        );
       // console.log("catalog list", items);
        const totalRecords = datas.ApiDocument.TotalRecords;
        setItems(filteredSelectedColumn(items2));
        setIsRecUpdated("Report Updated..");
     //   setFinalRec(filteredSelectedColumn());
        // setTotalRecords(totalRecords);
      //  setPending(false);
      })
      .catch((err) => console.log(err));
  };

  
  
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };
  const handleRowsPerPageChange = (newRowsPerPage) => {
    setRowsPerPage(newRowsPerPage); // Set the new rows per page value
  };

  //handle filter clear/////
 const handleFilterClear=()=>{
  // Clear previous custom filters
  //setIsLoading(true);
  //console.log(items)
  setFromDate('');
  setToDate('');
  setFilteredRecCount("");
  // setCurrentPage(0);
  // setRowsPerPage(0);
  setFinalRec([]);
  setStoreFilterRec([]);
  //setTotalRecords(items.length)
  setShowRec(false);
  //setSelectStore('')
  if(dynamicFields.length > 0){
  const list=[...dynamicFields];
  list.forEach((item)=>{
    return item.filterValue="";
  })
  setDynamicFields(list);
  //console.log(list);
  }else{
  setDynamicFields([{ filterName: "", filterType: "", filterValue: "",filterTypeOpt:[],filterNameOpt:[{value:"CLU",name:"CLU"},{value:"Description",name:"Description"},{value:"Cost",name:"Cost"},{value:"Base Price",name:"Base Price"},{value:"Primary Vendor",name:"Primary Vendor"},{value:"NSO",name:"NSO"},{value:"Status",name:"Status"},{value:"Department",name:"DEPARTMENT"},{value:"Class",name:"CLASS"},{value:"Pack",name:"PACK"},{value:"Web",name:"WEB"},{value:"Available Date",name:"AVAILABLE DATE"},{name:"Rec Modified",value:"Rec Modified"}] }]);
   }
   setIsOpen(false);
  }
  
    //////end/////////////////
  
    //dynamic filter column///
  
  const handleFilterCol=(e)=>{
    //console.log(e.target.value);
  }
  
    /////end/////////////
    //filter type column///
  
  const handleFilterType=(e)=>{
   // console.log(e.target.value);
  }
  
    /////end/////////////
  
    ///create dynamic filter field///
  const handleCreate=()=>{
    if(dynamicFields.length <=12){
      contentRef.current.style.maxHeight = `${contentRef.current.scrollHeight+75}px`;
      setDynamicFields([...dynamicFields,{ filterName: "", filterType: "", filterValue: "",filterTypeOpt:[],filterNameOpt:[{value:"CLU",name:"CLU"},{value:"Description",name:"Description"},{value:"Cost",name:"Cost"},{value:"Base Price",name:"Base Price"},{value:"Primary Vendor",name:"Primary Vendor"},{value:"NSO",name:"NSO"},{value:"Status",name:"Status"},{value:"Department",name:"DEPARTMENT"},{value:"Class",name:"CLASS"},{value:"Pack",name:"PACK"},{value:"Web",name:"WEB"},{value:"Available Date",name:"AVAILABLE DATE"},{name:"Rec Modified",value:"Rec Modified"}] }]);
    }
    
  }
    ///////end//////////////////////
    ////remove the filter fields///
  const handleRemove=(e)=>{
    if(e !=0){
      const list=[...dynamicFields];
      list.splice(e,1);
      setDynamicFields(list);
    }
   // console.log(e)
  }
  
  
    //////end////////////////////
  
    ////handle dynamic field values///
  const handleDynamicVal=(e,indx)=>{
    const {name,value}=e.target;
    console.log("selected valus->",value);

    // If a filter value is being updated, check if it's already selected
  if (name === "filterName") {
    // Get all the already selected filter names from dynamicFields (excluding the current one)
    const selectedFilterNames = dynamicFields
      .filter((_, index) => index !== indx) // Exclude the current field
      .map(field => field.filterName);
console.log("fetch filters",selectedFilterNames);
    // Check if the selected value already exists in another field
    if (selectedFilterNames.includes(value.trim())) {
      // If the selected value is already in use, alert the user and don't update
      toast.error("This filter option has already been selected. Please choose another.", {
        position: "top-center",
        autoClose: false,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        theme: "colored",
        className: "login-toast",
      });
      return; // Prevent updating the field
    }
  }

    const list =[...dynamicFields];
    list[indx][name]=value.trim();
    
    // switch(value){
    //   case "ticketno": list[indx].filterTypeOpt = [{value:"0",name:"="}]; break;
    //   default: list[indx].filterTypeOpt = [{value:"0",name:"="},{value:"1",name:">="},{value:"2",name:"<"},{value:"3",name:"<="}]; break; 
    // }
  
  
    switch(value){
  
      case "CLU": 
      // list[indx].filterNameOpt = [{value:"ticketno",name:"#Ticket No"}]; 
      list[indx].filterTypeOpt = [{value:"Equal",name:"="},{value:"Contains",name:"Contains"}]; 
      list[indx].filterStatusOpt = false;
      list[indx].filterNsoOpt = false;
      list[indx].filterValue="";
      list[indx].type="text";
      list[indx].filtersActiveOpt = false; 
      list[indx].filtersDateOpt = false;
      list[indx].enableSelect = false; 
      break;
      case "Description": 
      // list[indx].filterNameOpt = [{value:"subtotal",name:"Sub-Total(w/o tax)"}];
       list[indx].filterTypeOpt = [{value:"Equal",name:"="},{value:"Contains",name:"Contains"}];
       list[indx].filterStatusOpt = false;
       list[indx].filterNsoOpt = false;
       list[indx].type="text";
       list[indx].filtersActiveOpt = false; 
       list[indx].filtersDateOpt = false;
       list[indx].enableSelect = false; 
       break;
      case "Cost": 
      // list[indx].filterNameOpt = [{value:"discount",name:"Discount"}]; 
      list[indx].filterTypeOpt = [{value:"Equal",name:"="},{value:"1",name:">"},{value:"2",name:">="},{value:"3",name:"<"},{value:"4",name:"<="}];
      list[indx].filterStatusOpt = false;
      list[indx].filterNsoOpt = false;
      list[indx].type="number";
      list[indx].filtersActiveOpt = false; 
      list[indx].filtersDateOpt = false;
      list[indx].enableSelect = false; 
      break;
      case "Base Price": 
      // list[indx].filterNameOpt = [{value:"tax",name:"Tax"}];
      list[indx].filterTypeOpt = [{value:"Equal",name:"="},{value:"1",name:">"},{value:"2",name:">="},{value:"3",name:"<"},{value:"4",name:"<="}]; 
      list[indx].filterStatusOpt = false;
      list[indx].filterNsoOpt = false;
      list[indx].type="number";
      list[indx].filtersActiveOpt = false; 
      list[indx].filtersDateOpt = false;
      list[indx].enableSelect = false; 
      break;
      case "Primary Vendor":
        // list[indx].filterNameOpt = [{value:"sales",name:"Total Sales"}];
      list[indx].filterTypeOpt = [{value:"Equal",name:"="},{value:"Contains",name:"Contains"}]; 
      list[indx].filterStatusOpt = false;
      list[indx].filterNsoOpt = false;
      list[indx].type="text";
      list[indx].filtersActiveOpt = false; 
      list[indx].filtersDateOpt = false;
      list[indx].enableSelect = false; 
      break;
      case "NSO":
        // list[indx].filterNameOpt = [{value:"sales",name:"Total Sales"}];
      list[indx].filterTypeOpt = []; 
      list[indx].filterStatusOpt = false;
      list[indx].enableSelect = true; 
      list[indx].enableSelectOpt = [{name:"Yes",value:"true"},{name:"No",value:"false"}]; 
      list[indx].filterNsoOpt = true;
      list[indx].filtersActiveOpt = false; 
      list[indx].filtersDateOpt = false;
      break;
      case "UPC":
        // list[indx].filterNameOpt = [{value:"sales",name:"Total Sales"}];
      list[indx].filterTypeOpt = [{value:"Equal",name:"="},{value:"Contains",name:"Contains"}]; 
      list[indx].filterStatusOpt = false; 
      list[indx].filterNsoOpt = false;
      list[indx].type="number";
      list[indx].filtersActiveOpt = false; 
      list[indx].filtersDateOpt = false;
      list[indx].enableSelect = false; 
      break;
      case "Status":
        // list[indx].filterNameOpt = [{value:"sales",name:"Total Sales"}];
      list[indx].filterTypeOpt = []; 
      list[indx].filterStatusOpt = true; 
      list[indx].enableSelect = true; 
      list[indx].enableSelectOpt = [{name:"Approved",value:"Approved"},{name:"Pending Review",value:"Pending"},{name:"Rejected",value:"Rejected"},{name:"In Active",value:"In Active"},{name:"Discontinued",value:"Discontinued"}]; 
      list[indx].filterNsoOpt = false;
      list[indx].filtersActiveOpt = false; 
      list[indx].filtersDateOpt = false;
      break;
      case "Department":
        // list[indx].filterNameOpt = [{value:"sales",name:"Total Sales"}];
      list[indx].filterTypeOpt = [{value:"Equal",name:"="},{value:"Contains",name:"Contains"}];
      list[indx].filterStatusOpt =false; 
      list[indx].filterNsoOpt = false;
      list[indx].type="text";
      list[indx].filtersActiveOpt = false; 
      list[indx].filtersDateOpt = false;
      list[indx].enableSelect = false; 
      break;
      case "Class":
        // list[indx].filterNameOpt = [{value:"sales",name:"Total Sales"}];
      list[indx].filterTypeOpt = [{value:"Equal",name:"="},{value:"Contains",name:"Contains"}];
      list[indx].filterStatusOpt = false; 
      list[indx].filterNsoOpt = false;
      list[indx].type="text";
      list[indx].filtersActiveOpt = false;
      list[indx].filtersDateOpt = false;
      list[indx].enableSelect = false; 
      break;
      case "Pack":
        // list[indx].filterNameOpt = [{value:"sales",name:"Total Sales"}];
        list[indx].filterTypeOpt = [{value:"Equal",name:"="},{value:"1",name:">"},{value:"2",name:">="},{value:"3",name:"<"},{value:"4",name:"<="}]; 
        list[indx].filterStatusOpt = false;
        list[indx].filterNsoOpt = false;
        list[indx].type="number";
        list[indx].filtersActiveOpt = false; 
        list[indx].filtersDateOpt = false;
        list[indx].enableSelect = false; 
      break;
      case "Web":
        // list[indx].filterNameOpt = [{value:"sales",name:"Total Sales"}];
      list[indx].filterTypeOpt = []; 
      list[indx].filterStatusOpt = false;
      list[indx].filterNsoOpt = false;
      list[indx].enableSelect = true; 
      list[indx].enableSelectOpt = [{name:"Available",value:"yes"},{name:"Not Available",value:"no"}]; 
      list[indx].filtersActiveOpt = false; 
      list[indx].filtersDateOpt = false;
      break;
      case "Available Date":
        // list[indx].filterNameOpt = [{value:"sales",name:"Total Sales"}];
      list[indx].filterTypeOpt = [{value:"Equal",name:"="}]; 
      list[indx].filterStatusOpt = false;
      list[indx].filterNsoOpt = false;
      list[indx].filtersActiveOpt = false; 
      list[indx].filtersDateOpt = true;
      list[indx].enableSelect = false; 
      break;
      case "Active":
        list[indx].filterTypeOpt = []; 
        list[indx].filterStatusOpt = false; 
        list[indx].filtersActiveOpt = true; 
        list[indx].filterNsoOpt = false;
        list[indx].filtersDateOpt = false;
        list[indx].enableSelect = false; 
      break;
      case "Rec Modified":
        list[indx].filterTypeOpt = [{value:"Equal",name:"="}]; 
        list[indx].filterStatusOpt = false; 
        list[indx].filtersActiveOpt = false; 
        list[indx].filterNsoOpt = false;
        list[indx].filtersDateOpt = true;
        list[indx].enableSelect = false; 
      break;
     
    }
  
    setDynamicFields(list);
     console.log("filter",dynamicFields);
  }
 
    //////end////////////////////////
    
  ////filter functionality start here ////
 
   
  const getFilteredRec = async(type) => {
    setFinalRec([]);
    setSearch("");
    const filterObj = {
      cluLen: {},
      descriptionLen: {},
      upcLen1: {},
      costLen: {},
      priceLen: {},
      vendorLen: {},
      nsoLen: {},
      status: {},
      departmentLen:{},
      classLen:{},
      packLen:{},
      webLen:{},
      availableDateLen:{},
      activeLen:{},
    };
    
    dynamicFields.forEach((it) => {
      if(it.filterName !==""  && it.filterValue !=="" ){
        switch(it.filterName){
          case "CLU": filterObj.cluLen = it; break; 
          case "Description": filterObj.descriptionLen = it; break; 
          case "UPC": filterObj.upcLen1 = it; break;
          case "Cost": filterObj.costLen = it; break;
          case "Base Price": filterObj.priceLen = it; break;
          case "Primary Vendor": filterObj.vendorLen = it; break;
          case "NSO": filterObj.nsoLen = it; break;
          case "Status": filterObj.status = it; break;
          case "Department": filterObj.departmentLen = it; break;
          case "Class": filterObj.classLen = it; break;
          case "Pack": filterObj.packLen = it; break;
          case "Web": filterObj.webLen = it; break;
          case "Available Date": filterObj.availableDateLen = it; break;
          case "Active": filterObj.activeLen = it; break;
        }
      }
    });

    const findEmptyVal = dynamicFields.find(it => {
      if (it.filterTypeOpt.length > 0) {
        return it.filterName === "" || it.filterValue === "" || it.filterType === "";
      }else{
        return it.filterName === "" || it.filterValue === "";
      }
  
    });
    
    
    const cluLen = filterObj.cluLen;
    const descriptionLen = filterObj.descriptionLen;
    const upcLen1 = filterObj.upcLen1;
    const costLen = filterObj.costLen;
    const priceLen = filterObj.priceLen;
    const vendorLen = filterObj.vendorLen;
    const nsoLen = filterObj.nsoLen;
    const status = filterObj.status;
    const departmentLen = filterObj.departmentLen;
    const classLen = filterObj.classLen;
    const packLen = filterObj.packLen;
    const webLen = filterObj.webLen;
    const availableDateLen = filterObj.availableDateLen;
    const activeLen = filterObj.activeLen;
    
    if(!findEmptyVal || fromDate || toDate || availToDate || availFromDate ){
      console.log("it not empty");
    
      
    setIsLoading(true);
    setShowRec(false);

    console.log("check nso",nsoLen);
  
    let itemsFilter=[];
  //  console.log("check from date",fromDate)
//     if(fromDate || toDate){
// try{
//   const filterDataObj = {
//     "fromDate": fromDate,
//     "toDate": toDate
//   };
//   const extractFilterVal = dynamicFields.map((it) => {
//     // Dynamically set properties based on filterName
//     filterDataObj[it.filterName] = {
//       type: it.filterType,
//       value: it.filterValue
//     };
//   });
  
//  const res= await API.getData1(filterDataObj);
//  if(await res.ApiDocument.Response){
//   const itemsFilter1 =await res.ApiDocument.Response.Styles.flatMap(
//     (style) => style
//   );
//   const totalRecords = await res.ApiDocument.TotalRecords;
//   itemsFilter=filteredSelectedColumn(itemsFilter1)
//  }else{
//   //console.log("came here");
//   setStoreFilterRec([]);
//   setFinalRec([]);
//   setShowRec(true);
//  }


// }catch(err){
//   console.error("Error fetching Employee data:", err);
//  }
//     }else{
      //console.log("its came here!!")
      itemsFilter=items;
   // }
  
    
    function applyComparison(itemValue, filterValue, operator) {
      switch (operator) {
        case '1': // Greater than
          return itemValue > filterValue;
        case '3': // Less than
          return itemValue < filterValue;
        case '2': // Greater than or equal
          return itemValue >= filterValue;
        case '4': // Less than or equal
          return itemValue <= filterValue;
        case 'Equal': // Equal to
          return itemValue == filterValue;
        case 'Contains': // Contains (case-sensitive)
        if (typeof itemValue === 'string' && typeof filterValue === 'string') {
          return itemValue.toLowerCase().includes(filterValue.toLowerCase());
        }
          return false; // If it's not a string, don't match
        default:
          return false;
      }
    }
    
    
    // Function to apply multiple filters dynamically
    function applyFilters(data) {
      return data.filter((item) => {
        let matchesAllConditions = true; // Assume the item matches all conditions initially

        // Apply the CLU filter if it exists
        if (cluLen && cluLen.filterValue && cluLen.filterType) {
         // console.log(cluLen.filterType)
          matchesAllConditions = matchesAllConditions && applyComparison(item.CLU, cluLen.filterValue, cluLen.filterType);
        }

        // Apply the description filter if it exists
        if (descriptionLen && descriptionLen.filterValue && descriptionLen.filterType) {
          matchesAllConditions = matchesAllConditions && applyComparison(item.DESCRIPTION, descriptionLen.filterValue, descriptionLen.filterType);
        }

        // Apply the upc filter if it exists
        if (upcLen1 && upcLen1.filterValue && upcLen1.filterType) {
          matchesAllConditions = matchesAllConditions && applyComparison(Number(item.UPC), Number(upcLen1.filterValue), upcLen1.filterType);
        }
    
    
        // Apply the Cost filter if it exists
        if (costLen && costLen.filterValue && costLen.filterType) {
          matchesAllConditions = matchesAllConditions && applyComparison(Number(item.COST), Number(costLen.filterValue), costLen.filterType);
        }
    
        // Apply the Price filter if it exists
        if (priceLen && priceLen.filterValue && priceLen.filterType) {
          matchesAllConditions = matchesAllConditions && applyComparison(Number(item["BASE PRICE"]), Number(priceLen.filterValue), priceLen.filterType);
        }
    
        // Apply the Vendor filter if it exists
        if (vendorLen && vendorLen.filterValue && vendorLen.filterType) {
          matchesAllConditions = matchesAllConditions && applyComparison(item["PRIMARY VENDOR"], vendorLen.filterValue, vendorLen.filterType);
        }
    
        // Apply the NSO filter if it exists
        if (nsoLen && nsoLen.filterValue) {
         
          matchesAllConditions = matchesAllConditions && applyComparison(String(item["NSO"]), String(nsoLen.filterValue), "Equal");
          
        }
    
        // Apply the Status filter if it exists
        if (status && status.filterValue) {
          matchesAllConditions = matchesAllConditions && applyComparison(item["STATUS"], status.filterValue, "Equal");
        }

         // Apply the department filter if it exists
         if (departmentLen && departmentLen.filterValue && departmentLen.filterType) {
          matchesAllConditions = matchesAllConditions && applyComparison(item["DEPARTMENT"], departmentLen.filterValue, departmentLen.filterType);
        }

         // Apply the class filter if it exists
         if (classLen && classLen.filterValue && classLen.filterType) {
          matchesAllConditions = matchesAllConditions && applyComparison(item["CLASS"], classLen.filterValue, classLen.filterType);
        }

        // Apply the pack filter if it exists
        if (packLen && packLen.filterValue && packLen.filterType) {
          matchesAllConditions = matchesAllConditions && applyComparison(item["PACK"], Number(packLen.filterValue), packLen.filterType);
        }
        // Apply the Web filter if it exists
        if (webLen && webLen.filterValue) {
          matchesAllConditions = matchesAllConditions && applyComparison(item["WEB"], webLen.filterValue,"Equal");
        }
       // Apply the available date filter if it exists
        if (availFromDate) {
          // console.log(item)
          matchesAllConditions = matchesAllConditions && applyComparison(new Date(item["AVAILABLE DATE"]), new Date(availFromDate), "2");
        }
        if (availToDate) {
          matchesAllConditions = matchesAllConditions && applyComparison(new Date(item["AVAILABLE DATE"]), new Date(availToDate), "4");
        }
        // Apply the Rec date filter if it exists
        if (fromDate) {
          // console.log(item)
          matchesAllConditions = matchesAllConditions && applyComparison(new Date(item["Last Modified"]), new Date(fromDate), "2");
        }
        if (toDate) {
          matchesAllConditions = matchesAllConditions && applyComparison(new Date(item["Last Modified"]), new Date(toDate), "4");
        }
        // Apply the Active filter if it exists
        if (activeLen && activeLen.filterValue && activeLen.filterType) {
          matchesAllConditions = matchesAllConditions && applyComparison(item["ACTIVE"], activeLen.filterValue, activeLen.filterType);
        }
    
        // Return the item if it matches all conditions
        return matchesAllConditions;
      });
    }
    
    if(itemsFilter.length > 0){
      // console.log("check before filter",itemsFilter);
      const filteredData = applyFilters(itemsFilter);
     console.log(filteredData);
      if(filteredData.length == 0){
        setShowRec(true);
      }
    
      setTimeout(()=>{
        setFilteredRecCount(filteredData.length);
        setIsLoading(false);
        // setItems(filteredData);
         setStoreFilterRec(filteredData);
      //   setTotalRecords(filteredData.length);
         setIsOpen(false);
         //setFinalRec(filteredSelectedColumn());
      },1000);
    }else{
    //  setItems([]);
     
      setTimeout(()=>{
        setFilteredRecCount(0);
        setFinalRec([]);
        setStoreFilterRec([])
       // setTotalRecords(0);
        setIsLoading(false)
        setIsOpen(false)
      },1000);
    }
    
    } else {
      toast.error("Please ensure filters are correctly selected before proceeding.", {
        position: "top-center",
        autoClose: false,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        theme: "colored",
        className: "login-toast",
      });
    }
    
    
           };

  ////////filter functionality end here////////////////

  ////column reorder functionality begin here////
  // Function to update original columns based on reordered data
  const updateOriginalColumns = (reordered) => {
    // Map the reordered columns to their ids
    const reorderedOrder = reordered.map((col) => col.id);

    // Reorder original columns based on the reorderedOrder
    const updatedColumns = columns
      .sort((a, b) => reorderedOrder.indexOf(a.id) - reorderedOrder.indexOf(b.id));
    return updatedColumns;
  };
// Store column order in cookies
const handleColumnOrderChange = (newOrder,getCol) => {
//console.log("reorder",newOrder);
let result;
if(getCol === "visiblecol"){
  result=newOrder;
}else{
  result = [
    ...newOrder,
    ...columns.filter(item => !newOrder.some(existing => existing.id === item.id))
  ];
}
  Cookies.set("ProductsOrder2", JSON.stringify(result), { expires: 365 }); // Save for 365 days
};


///show column visibility modal//
const showModal = () => {
    
    setShowDatePickerModal(true);
  };

/////end/////////////////////

  /////column reorder functionality end here////

   // Convert JSON data to an Excel file format
   const handleExcelExport = () => {
    const getDatas2=exportVisibleCol(finalRec.length > 0 ? finalRec :storeFilterRec.length > 0 ? storeFilterRec : showRec ? storeFilterRec :items);
     console.log("filtered export",getDatas2);
// return false;
    
    const ws = XLSX.utils.json_to_sheet(getDatas2);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Product List");
    
    
    
    // Construct the filename with USA formatted date and time
    const filename = `product-list_${getTime()}.xlsx`;
    
    // Write to file
    XLSX.writeFile(wb, filename);
};

// Copy data to clipboard
const handleCopyData = () => {
  const getDatas3=exportVisibleCol(finalRec.length > 0 ? finalRec :storeFilterRec.length > 0 ? storeFilterRec : showRec ? storeFilterRec :items);
  // Check if items array has data
  if (getDatas3.length === 0) {
    toast.error("No data available to copy.", {
      position: "top-center",
      autoClose: false,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      theme: "colored",
      className: "login-toast",
    });
  //  alert("No data available to copy.");
    return;
  }
  
  // Dynamically generate the headers based on the keys of the first item in the items array
  const headers = Object.keys(getDatas3[0]);

  // Map the data into rows, dynamically handling each key-value pair for each item
  const tableData = getDatas3
    .map(item => {
      // For each item, get the value for each header, or "N/A" if the value is undefined
      return headers
        .map(header => item[header] ? `${item[header]}` : "-") // Fallback to "N/A" for missing values
        .join("\t"); // Join each value with a tab to separate columns
    })
    .join("\n"); // Join rows with newlines

  // Add the headers as the first row of the table data
  const headerRow = headers.join("\t");
  const fullText = `${headerRow}\n${tableData}`;

  // Copy the dynamically generated table data to clipboard
  navigator.clipboard.writeText(fullText)
    .then(() => {
      toast.success("Data copied to clipboard!", {
        position: "top-center",
        autoClose: false,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        theme: "colored",
        className: "login-toast",
      });
    //  alert('Data copied to clipboard!');
    })
    .catch((err) => {
      toast.error("Failed to copy data!", {
        position: "top-center",
        autoClose: false,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        theme: "colored",
        className: "login-toast",
      });
      console.error('Error copying text: ', err);
    //  alert('Failed to copy data!');
    });
};

// Function to trigger print
const handlePrint = () => {
  const getDatas=exportVisibleCol(finalRec.length > 0 ? finalRec :storeFilterRec.length > 0 ? storeFilterRec : showRec ? storeFilterRec :items);
    //console.log(updatedData);
    //return false;
  const printWindow = window.open("", "_blank");
  
  // Start creating the HTML for the table
  let tableContent = "<html><head><title>Product List</title>";
  tableContent += `
    <style>
      table {
        width: 100%;
        border-collapse: collapse;
      }
      th, td {
        border: 1px solid black;
        padding: 8px;
        text-align: left;
      }
      th {
        background-color: #f2f2f2;
      }
      td {
        word-wrap: break-word;
      }
    </style>
  `;
  tableContent += "</head><body>";
  
  // Start the table structure
  tableContent += "<table>";
  tableContent += "<thead><tr>";
  const keys = Object.keys(getDatas[0]);
  keys.forEach((item)=>{
    tableContent +=`<th>${item}</th>`;
  //console.log(updatedData)
  })
  tableContent +="</tr></thead><tbody>";
  //tableContent += "<thead><tr><th>CLU</th><th>Description</th></tr></thead><tbody>";
 // console.log(updatedData)
  //return false;
  // Add the rows for each key-value pair in the JSON
  getDatas.forEach((item)=>{
    tableContent +=`<tr>`
    keys.forEach((it)=>{
      if(item[it]){
        tableContent += `<td>${item[it]}</td>`;
      }else{
        tableContent += `<td>-</td>`;
      }
      
    })
    tableContent +=`</tr>`;
  })
  // for (const [key, value] of Object.entries(updatedData)) {
  //   console.log(key);
  //   console.log(value)
  //  // tableContent += `<tr><td>${CLU}</td></td></tr>`;
  // }
//return false;
  // Close the table and HTML
  tableContent += "</tbody></table>";
  tableContent += "</body></html>";
  
  // Write the content to the new window and print
  printWindow.document.write(tableContent);
  printWindow.document.close();
  printWindow.print();
};

//////end//////////

///////export pdf start/////////////////
const handleExportPDF = () => {
  const getDatas = exportVisibleCol(finalRec.length > 0 ? finalRec :storeFilterRec.length > 0 ? storeFilterRec : showRec ? storeFilterRec :items);

  // Create a new jsPDF instance
  const doc = new jsPDF();

  // Prepare the data for the table
  const tableContent = [];
  const keys = Object.keys(getDatas[0]);

  // Add headers to the tableContent
  const headers = keys;
  tableContent.push(headers);

  // Add rows for each item
  getDatas.forEach((item) => {
    const row = keys.map((key) => (item[key] ? item[key] : "-"));
    tableContent.push(row);
  });
  

  // Use jsPDF's autoTable plugin to create the table in the PDF
  doc.autoTable({
    head: [headers],
    body: tableContent.slice(1), // Skip the header row for the body
    theme: "grid", // Optional: Use grid style for the table
    margin: { top: 10 },
    
  });

  // Save the generated PDF
  doc.save(`Product_List_${getTime()}.pdf`);
};


///////export pdf end///////////////////


/////filtered the data based on visible column//////
const exportVisibleCol=(get)=>{
 // console.log(get);
  const filterVisibleData=get.map((item)=>{
    let filteredItem={};
    columns.forEach((it)=>{
      if (it.name ==="CLU" && it.columnVisible ===true) {
        filteredItem["CLU"] = item.CLU;
      }
      if(it.name ==="DESCRIPTION" && it.columnVisible ===true){
        filteredItem["DESCRIPTION"] = item.DESCRIPTION;
      }
      if(it.name ==="Last Modified" && it.columnVisible ===true){
        filteredItem["Last Modified"] = item["Last Modified"];
      }
      if(it.name ==="COST" && it.columnVisible ===true){
        filteredItem["COST"] = item.COST;
      }
      if(it.name ==="BASE PRICE" && it.columnVisible ===true){
        filteredItem["BASE PRICE"] = item["BASE PRICE"];
      }
      if(it.name ==="PRIMARY VENDOR" && it.columnVisible ===true){
        filteredItem["PRIMARY VENDOR"] = item["PRIMARY VENDOR"];
      }
      if(it.name ==="NSO" && it.columnVisible ===true){
        filteredItem["NSO"] = item.NSO;
      }
      if(it.name ==="UPC" && it.columnVisible ===true){
        filteredItem["UPC"] = item.UPC;
      }
      if(it.name ==="STATUS" && it.columnVisible ===true){
        filteredItem["STATUS"] = item.STATUS;
      }
      if(it.name ==="DEPARTMENT" && it.columnVisible ===true){
        filteredItem["DEPARTMENT"] = item["DEPARTMENT"];
      }
      if(it.name ==="CLASS" && it.columnVisible ===true){
        filteredItem["CLASS"] = item["CLASS"];
      }
      if(it.name ==="PACK" && it.columnVisible ===true){
        filteredItem["PACK"] = item["PACK"];
      }
      if(it.name ==="WEB" && it.columnVisible ===true){
        filteredItem["WEB"] = item["WEB"];
      }
      if(it.name ==="AVAILABLE DATE" && it.columnVisible ===true){
        filteredItem["AVAILABLE DATE"] = item["AVAILABLE DATE"];
      }
      // if(it.name ==="ACTIVE" && it.columnVisible ===true){
      //   filteredItem["ACTIVE"] = item["ACTIVE"];
      // }
      if(it.name ==="CURRENT CATALOG" && it.columnVisible ===true){
        filteredItem["CURRENT CATALOG"] = item["CURRENT CATALOG"];
      }
     

    })
    return filteredItem;
  })
  
  return filterVisibleData;
}

/////////////////////end/////////////////////////////

////
const filteredSelectedColumn=(items)=>{
  //const getData=storeFilterRec.length > 0 ? storeFilterRec : showRec ? storeFilterRec :items;
   console.table("Error check",items);
    const updatedData = items.map((item) => {
      // Filter to include only matching key-value pairs from filteredColumns
      const filteredItem = {};
    
      filteredColumns.forEach((it) => {
        filteredItem["StyleNo"] = item.StyleNo || "";

        filteredItem["CLU"] = item.Items && item.Items[0] ? item.Items[0].CLU || "" : "";
        
        filteredItem["DESCRIPTION"] = item.StoreDescription || "";
        
        filteredItem["Last Modified"] = item.RecModified ? formatDate(item.RecModified) : "";
        
        filteredItem["COST"] = item.OrderCost ? `$${item.OrderCost.toFixed(2)}` : "$0.00";
        
        filteredItem["BASE PRICE"] = item.Items && item.Items[0] && item.Items[0].BasePrice ? `$${item.Items[0].BasePrice.toFixed(2)}` : "$0.00";
        
        filteredItem["PRIMARY VENDOR"] = item.PrimaryVendorIdentifier || "";
        
        filteredItem["NSO"] = item.Custom && item.Custom.CustomFlag3 ? item.Custom.CustomFlag3 : "";
        
        filteredItem["UPC"] = item.Items && item.Items[0] && item.Items[0].UPC ? item.Items[0].UPC : "";
        
      //  filteredItem["Status"] = item.Custom && item.Custom.CustomLookup12 ? item.Custom.CustomLookup12 : "";
        
        if (item.Items && item.Items[0] && item.Items[0]["Discontinued"] === false) {
          if (item.Inactive === false) {
            if (item.Custom && item.Custom.CustomLookup12) {
              if (item.Custom.CustomLookup12 === "Approved") {
                filteredItem["STATUS"] = "Approved";
              } else if (item.Custom.CustomLookup12 === "Pending Review" || item.Custom.CustomLookup12 === "In Review") {
                filteredItem["STATUS"] = "Pending";
              } else if (item.Custom.CustomLookup12 === "Rejected") {
                filteredItem["STATUS"] = "Rejected";
              }
            }
          } else {
            filteredItem["STATUS"] = "In Active";
          }
        } else {
          filteredItem["STATUS"] = "Discontinued";
        }
        
        
        filteredItem["DEPARTMENT"] = item.DCSS && item.DCSS.DeptName ? item.DCSS.DeptName : "";
        
        filteredItem["CLASS"] = item.DCSS && item.DCSS.ClassName ? item.DCSS.ClassName : "";
        
        filteredItem["PACK"] = item.Items && item.Items[0] && item.Items[0].Custom && item.Items[0].Custom.CustomNumber1 ? item.Items[0].Custom.CustomNumber1 : "";
        
        filteredItem["WEB12"] = item.EChannels || "";

        
        if(item.EChannels && item.EChannels[0] && item.EChannels[0].Status.trim() !=""){
          if(item.EChannels[0].Status.trim() ==="EcOffer"){
           // console.log(item.EChannels[0].Status)
            filteredItem["WEB"]="yes";
          }else{
            filteredItem["WEB"]="no";
          }
          
        }else{
          filteredItem["WEB"]="";
        }
        
    //    filteredItem["WEB"] = item.EChannels && item.EChannels[0] ? item.EChannels[0].Status : "";
        
        
        filteredItem["AVAILABLE DATE"] = item.Items && item.Items[0] && item.Items[0].DateAvailable ? formatDate(item.Items[0].DateAvailable) : "";
        
        // filteredItem["ACTIVE"] = item.Inactive === true ? (
        // 'Inactive'
        // ) : (
        //   'Active'
        // );
        filteredItem["CURRENT CATALOG"] = item.CustomLookup8 || "";

        filteredItem["ALL_PRICES"] = item.Items && item.Items[0] && item.Items[0].Prices ?item.Items[0].Prices :"";
       

      });
    
      return filteredItem;
    })
   // console.log(updatedData);
    return updatedData;
}

///////////////////////////end///////////////////////


/////get the timezone for filename/////

const getTime=()=>{
   // Get current date and time in MM-DD-YYYY_HH-mm-ss format
   const currentDate = new Date();
   const month = (currentDate.getMonth() + 1).toString().padStart(2, '0'); // MM
   const day = currentDate.getDate().toString().padStart(2, '0'); // DD
   const year = currentDate.getFullYear(); // YYYY
   const hours = currentDate.getHours().toString().padStart(2, '0'); // HH
   const minutes = currentDate.getMinutes().toString().padStart(2, '0'); // mm
   const seconds = currentDate.getSeconds().toString().padStart(2, '0'); // ss

   return `${month}-${day}-${year}_${hours}-${minutes}-${seconds}`;
}



////////////////end/////////////////////

////////global search filter//////
// useEffect(()=>{
//   if(search !==""){
//      handleSearch(search);
//   }
// },[storeFilterRec]);
const handleSearch=(e)=>{
  
 const getUpdatedData=storeFilterRec.length > 0 ? storeFilterRec : showRec ? storeFilterRec :items;
  const query=e.toLowerCase();
  setSearch(e);
//console.log("filter",storeFilterRec);
// Filter the data based on search query
// Filter the data based on search query, excluding empty values
//console.log("store filtered rec",storeFilterRec);
  const filteredData = getUpdatedData.filter(item =>
    Object.values(item).some(value => {
      // Skip empty values
      if (value === null || value === undefined || value === "") {
        return false;
      }
      return value.toString().toLowerCase().includes(query);
    })
  );
  if(filteredData.length > 0){
    if(e ===""){
      setFilteredRecCount("");
    }else{
      setFilteredRecCount(filteredData.length);
    }
   
    setFinalRec(filteredData)
  }else{
    setFilteredRecCount(0);
    // console.log("it empty here...")
    setFinalRec([]);
  }
//console.log(filteredData)
//console.log("total items",items)
}



////////global search filter end //////


/////clear globla search here///
const handleSearchClear=()=>{
setSearch("")
setFinalRec([]);
setFilteredRecCount("");
}
/////global search clear end here/////



  const selectStyles = {
    width: "100%",
    padding: "8px",
    fontSize: "14px",
    borderRadius: "4px",
    border: "1px solid #ced4da",
    backgroundColor: "#fff",
    marginTop:"-3px",
    outline: "none",
    cursor: "pointer",
    height: "47px",
    color: "black",
  };


  return (
    <>
      <div className="container-fluid page-body-wrapper">
      <div>
                      {/* Modal */}
                      <div
                        className={`modal fade ${showModal1 ? "show" : ""}`}
                        tabIndex="-1"
                        style={{ display: showModal1 ? "block" : "none" }}
                        aria-hidden={!showModal1}
                       >
                        <div className="modal-dialog modal-lg">
                          {" "}
                          {/* Add modal-lg class here for large modal */}
                          <div className="modal-content">
                            {/* Modal Header */}
                            <div className="modal-header">
                              <h5 className="modal-title">
                                All Store Price Level
                              </h5>
                              <button
                                type="button"
                                className="close"
                                onClick={toggleCloseModal}
                              >
                                <span aria-hidden="true">&times;</span>
                              </button>
                            </div>

 {/* Modal Body */}
 <div className="modal-body">
                              <div class="grid grid-4">
                                {prices.map((priceLevel, index) => {
                                    if(priceLevel.PriceLevel !=="BASEPRICE")
                                   return <div class="form-group">
                                    <label>{priceLevel.strname} (#{priceLevel.PriceLevel})</label>
                                    <input
                                      type="number"
                                      className="priceLevel"
                                      id={priceLevel.PriceLevel}
                                      value={priceLevel.Price}
                                     
                                    />
                                  </div>
                                }
                                  
                                )}
                              </div>
                            </div>

                            {/* Modal Footer */}
                            <div className="modal-footer">
                              {/* <button type="button" className="btn btn-secondary" onClick={toggleModal}>
                Close
              </button> */}
                              {/* <button type="button" className="btn btn-primary" onClick={toggleModal}>
                Save changes
              </button> */}
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Optional: Overlay for modal */}
                      {showModal1 && (
                        <div className="modal-backdrop fade show" />
                      )}
                    </div>

        <div className="main-panel">
          <div className="content-wrapper">
          <ToastContainer
                position="top-center"
                autoClose={500}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="colored"
              />
          {isLoading ? <div className="loader-overlays">
            <RotatingLines
                      visible={true}
                      height="96"
                      width="96"
                      strokeColor="white"
                      strokeWidth="2"
                      animationDuration="0.75"
                      ariaLabel="rotating-lines-loading"
                    /></div> : null}   
           
            <div class="Card_contend">
            <div  className="row">
                  <div className="col-md-6">
                  {storeCurrPerm?.add_permission === "1" ? (
            <>                  <button className="btn btn-primary additembutton1" >
                    <Link to="/upcchecker">ADD NEW ITEM</Link>
                  </button>
                
      <button
      style={{marginLeft:"10px"}}
        className={`btn btn-${isOpen ? 'secondary' : 'primary'}`}
        onClick={toggleCollapse}
      >
        {isOpen ? 'CLOSE' : 'FILTER'}
      </button>
      </>
  
            ) : (null)}
                  <button
                  style={{marginLeft:"10px"}}
          className="btn btn-secondary dropdown-toggle"
          type="button"
          onClick={showModal}
        >
          Column visibility
        </button>
                  </div>
                 
                  
        
                  </div>

                

      {/* Collapsible content with smooth transition */}
      <div
        ref={contentRef}
        style={{
          maxHeight: isOpen ? '0' : '0', // start collapsed
          overflow: 'hidden',
          transition: 'max-height 0.5s ease-in-out', // Apply smooth transition on max-height
        }}
      >
        <div className="card card-body mt-3 filterCard">
            
            {dynamicFields.map((item,index)=>{
            //  {console.log(item.filterValue)}
              return(
              <div className="row mt-3"> 
            <div className="col-md-3">

            <label  className="form-label">
                       Select Filter
                     </label>
                     <select  style={selectStyles} onChange={e=>handleDynamicVal(e,index)} name="filterName"  value={item.filterName}>

                         <option value=''>Select</option>
                         {item.filterNameOpt.map((i)=>{
                          return  <option value={i.value}>{i.name}</option>
                         })}
                       
                     </select>
            </div>
            {item.filterTypeOpt.length > 0 ? (
              <div className="col-md-3">
              {!item.filtersDateOpt ? (
                <>
                 <label  className="form-label">
                 Select Type
                          </label>
                          <select  style={selectStyles} onChange={e=>handleDynamicVal(e,index)} name="filterType"  value={item.filterType}>
                          <option value=''>Select</option>
                             {item.filterTypeOpt.map((i)=>{
                               return <option value={i.value}>{i.name}</option>
                             })}
                             
                          </select></>
              ):(
<>
<label htmlFor="fromDate" className="form-label">
From Date
</label>
<input
type="date"
id="fromDate"
className="form-control"
// style={{ width: "50%" }}
value={item.filterName==="Rec Modified" ?fromDate : availFromDate}
 onChange={(e)=>item.filterName==="Rec Modified" ?setFromDate(e.target.value) : setAvailFromDate(e.target.value)}
/></>
              )}
           
            </div>
            ):(null)}
            
            <div className="col-md-3">
              {item.filtersDateOpt ? (
                <>
                <label htmlFor="toDate" className="form-label">
                      To Date
                    </label>
                    <input
                      type="date"
                      id="toDate"
                      // style={{ width: "50%" }}
                      className="form-control"
                      value={item.filterName==="Rec Modified" ?toDate : availToDate}
                       onChange={item.filterName==="Rec Modified" ? (e)=>setToDate(e.target.value): (e)=>setAvailToDate(e.target.value)}
                    />
                </>
              ):(
<>
<label  className="form-label">
            Value
                     </label>
                     {
  item.enableSelect ? (
    <select style={selectStyles} name="filterValue" onChange={e => handleDynamicVal(e, index)} value={item.filterValue}>
      <option value="">Select</option>
      {item.enableSelectOpt.map((it) => {
        return <option key={it.value} value={it.value}>{it.name}</option>;  // Added return statement here
      })}
    </select>
  ) : (
    <input type={item.type} style={selectStyles} className="form-control" name="filterValue" onChange={e => handleDynamicVal(e, index)} value={item.filterValue} />
  )
}

                     {/* {
                     item.filtersActiveOpt ? (<select style={selectStyles} name="filterValue" onChange={e=>handleDynamicVal(e,index)}  value={item.filterValue}><option value="">Select</option><option value="Active">Active</option><option value="Inactive">InActive</option></select>) :
                     item.filterStatusOpt ? (
                      <select style={selectStyles} name="filterValue" onChange={e=>handleDynamicVal(e,index)}  value={item.filterValue}><option value="">Select</option><option value="Approved">Approved</option><option value="Pending">Pending Review</option><option value="Rejected">Rejected</option><option value="In Active">In Active</option><option value="Discontinued">Discontinued</option></select>
                     ): item.filterNsoOpt ? (
                      <select style={selectStyles} name="filterValue" onChange={e=>handleDynamicVal(e,index)}  value={item.filterValue}><option value="">Select</option><option value="true">Yes</option><option value="false">No</option></select>
                     ) :  ()
                    } */}
</>
              )}
           
                     
            </div>
            <div className="col-md-3">
              <div style={{marginTop:"30px"}}>
              {dynamicFields.length-1 ===index && <i class="mdi mdi-plus-circle"  style={{fontSize:"26px",color:"#0062ff",cursor:"pointer"}} onClick={handleCreate}/>}
             {dynamicFields.length >1 && <i class="mdi mdi-close-circle"  style={{fontSize:"26px",color:"",cursor:"pointer"}} onClick={()=>handleRemove(index)}/>} 
              </div>


            </div>
            </div>)
            })}
          <div className="row"> 
            
              
                  
            <div className="col-md-12 text-center">
              
              <button
                className="btn btn-primary"
               style={{marginTop:"29px"}}
                onClick={getFilteredRec}
              >
                APPLY
              </button>
             
              <button
                className="btn btn-secondary"
               style={{marginTop:"29px",marginLeft:"10px"}}
                onClick={handleFilterClear}
              >
                CLEAR
              </button>
            </div>

      </div>
            
                </div>
      </div>
                <div className="productbody" style={{position:"relative"}}>
                  <div style={{marginTop:"15px",position:"relative"}} className="row"> 
                    <div className="col-md-6"><input type="text" className="form-control" style={{...selectStyles,height: "43px",width:"200px"}} placeholder="search" onChange={(e)=>handleSearch(e.target.value)} value={search}/>
                    {search !=="" ? (<span className="clearsearch" onClick={handleSearchClear}>×</span>):(null)}</div>
                    <div className="col-md-6">
                     {/* Action Buttons with MDI CSS Icons */}
         <div style={{marginLeft:"auto",display:"flex",gap:"10px",justifyContent:"end"}}>
                {/* CSV Export with Icon */}
                <CSVLink 
                    data={exportVisibleCol(finalRec.length > 0 ? finalRec :storeFilterRec.length > 0 ? storeFilterRec : showRec ? storeFilterRec :items)}
                    filename={`product-list_${getTime()}.csv`}
                    className="customDT"
                >
                    <i className="mdi mdi-file-excel"></i> Export CSV
                </CSVLink>

                {/* Excel Export with Icon */}
                <button onClick={handleExcelExport} className="customDT">
                    <i className="mdi mdi-file-excel"></i> Export Excel
                </button>

                 {/* Pdf Export with Icon */}
                 <button onClick={handleExportPDF} className="customDT">
                    <i className="mdi mdi-file-pdf"></i> Export Pdf
                </button>

                {/* Print Button with Icon */}
                <button onClick={handlePrint} className="customDT">
                    <i className="mdi mdi-printer"></i> Print
                </button>

                {/* Copy Button with Icon */}
                {/* <button onClick={handleCopyData} className="btn btn-outline-primary">
                    <i className="mdi mdi-clipboard"></i> Copy Data
                </button> */}
            </div>
                  </div>
                    
                  </div>
       
        {/* Modal for password reset */}
        {showDatePickerModal ? (
          <div
           className="columnvisible_bg"
            onClick={() => setShowDatePickerModal(false)}
          >
            <div
              style={{
                backgroundColor: "white",
                padding: "1rem",
                borderRadius: "5px",
                width: "818px",
                marginTop: "40px",
                boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
              }}
              onClick={(e) => e.stopPropagation()} // Prevent modal from closing when clicking inside
            >
                   {/* <h5 className="text-center">Column visibility control</h5> */}
                   <div className="row" >
                    {console.log("col",columns)}
  {columns.map((col, index) => (
    col.name !=="CLU" ? (<div className="col-md-3 customVisible"  id={col.id} onClick={() => toggleColumn(col.id)}>
      {/* <input type="checkbox" id={col.id}  checked={col.columnVisible}
      onChange={() => toggleColumn(col.id)}  /> */}
      <label >{col.name}{col.columnVisible ===true &&<span style={{position:"absolute",right:"1em"}}>✓</span>}</label>

  </div>):(null)
    
 
//    <div key={index} className="col-6 d-flex align-items-center">
//       {/* Checkbox first */}
//       <input
//         type="checkbox"
//         className="form-check-input me-2"
//         id={col}
//         // checked={col.isVisible}
//         onChange={() => toggleColumn(col)}
//       />
//       {/* Label follows the checkbox */}
//       <span className="form-check-label" htmlFor={col}>
//         {col}
//       </span>
//     </div>
  ))}
</div>

            
            </div>
          </div>
        ) : null}

      
                  {!isLoading ? (
                    <div>
                     {/* <DataTableExtensions
                     columns={filteredColumns} // Pass columns directly
                     data={storeFilterRec.length > 0 ? storeFilterRec : showRec ? storeFilterRec :items}      // Pass data directly
                     export={false}      // Enable export buttons
                     print={false}       // Enable print button
                     exportHeaders={false} // Optional: include headers in exported files
                     printTitle="Product List" // Optional: title for the print version
                     filterPlaceholder="Search"
                
              > */}
               
                <DataTable
  title="Product List"
  className="table table-striped table-bordered table-hover"
  columns={filteredColumns}
  data={finalRec.length > 0 ? finalRec : storeFilterRec.length > 0 ? storeFilterRec : showRec ? storeFilterRec : items}  
  pagination
  paginationPerPage={25} // Set default rows per page to 25
  paginationRowsPerPageOptions={[25, 50, 100,200]}
  paginationTotalRows={totalRecords}  
  onColumnOrderChange={handleColumnOrderChange}
  persistTableHead={true}
  progressPending={pending}
  progressComponent={
    <div className="loader">
      <RotatingLines
        visible={true}
        height="96"
        width="96"
        strokeColor="grey"
        strokeWidth="2"
        animationDuration="0.75"
        ariaLabel="rotating-lines-loading"
      />
    </div>
  }
  //  fixedHeader
  // fixedHeaderScrollHeight="300px"
  // highlightOnHover
  responsive
   customStyles={{
    headCells: {
      style: {
        '&:first-child': {
          fontWeight: 'bold',
          backgroundColor: '#738b9c', // Set the background color for the first header
          color: 'white',
          position: 'sticky',
          left: 0,
          zIndex: 1000,
        },
      },
    },
   }}
/>

              {/* </DataTableExtensions> */}
             
              </div>
        
                  ) :(null) }
                                 
                 
                </div>
                <div>
{filteredRecCount !=="" ?(<div ><span className="mdi mdi-filter" style={{color:"#0062ff"}}></span><span style={{fontSize:"14px",fontWeight:"500",color:"#333"}}>Filter Count: {filteredRecCount}</span></div>):(null)}
        
{isRecUpdated !==""? <div style={{marginTop:"10px"}}><><span className="mdi mdi-checkbox-marked-circle rec_update"></span><span style={{fontSize:"14px",fontWeight:"500",marginLeft:"2px"}}>{isRecUpdated}</span></> </div>:""}
        </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
